<template>
  <div id="previous-base-states">
    <page-header :title="$t('Korábbi bázisállapotok')"/>
    <configurable-list
      v-if="!this.$route.params.id"
      :title="$t('Bázisállapotok')"
      :hasNavigation="true"
      @navigateBack="navigateToOrigin"
      :data="baseStates"
      :fields="fields"
      :loadingText="loadingText"
    />
    <configurable-list
      v-else-if="this.$route.params.id && allStatement"
      :hasNavigation="true"
      @navigateBack="navigateBack"
      :title="$t('app.statements.title')"
      :data="allStatement"
      :fields="statementFields"
      :loadingText="statementLoadingText"
    />
    <paginator-component
      :totalPages="totalPages"
      :currentPageIndex="currentPageIndex"
      @itemSelected="itemSelected"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ConfigurableList from '@/components/shared/lists/ConfigurableList';
import PageHeader from '@/components/shared/layouts/PageHeader';
import Paginator from '@/components/shared/navigations/Paginator';

export default {
  name: 'PreviousBaseStateScreen',
  components: {
    'configurable-list': ConfigurableList,
    'page-header': PageHeader,
    'paginator-component': Paginator,
  },
  props: {
  },
  data() {
    return {
      totalPages: 0,
      currentPageIndex: 1,
      baseStates: [],
      fields: [
        {
          title: 'Azonosító',
          isLink: true,
          cellClass: 'identifier-cell',
          route_path: 'base_states/previous_base_states',
          key: 'id',
        },
        {
          title: 'Státusz',
          key: 'status',
          withTranslation: true,
          translation: 'app.base_states',
        },
        {
          title: 'Módosító személy',
          key: 'last_modified_user',
        },
        {
          title: 'Létrehozás dátuma',
          isDate: true,
          key: 'created_at',
        },
        {
          title: 'Szerkesztés dátuma',
          isDate: true,
          key: 'updated_at',
        },
      ],
      statementFields: [
        {
          title: 'Azonosító',
          cellClass: 'identifier-cell',
          key: 'identifier',
        },
        {
          title: 'Témakör',
          cellClass: 'category-cell',
          key: 'criteria_category_name',
        },
        {
          title: 'Kérdés',
          cellClass: 'question-cell',
          key: 'verification_question_name',
        },
        {
          title: 'Megállapítás',
          cellClass: 'statement-cell',
          key: 'statement',
        },
        {
          title: this.$t('app.navigation.partner_navbar.sites'),
          cellClass: 'location-cell',
          arrayAttribute: 'name',
          key: 'locations',
        },
        {
          title: 'Extra',
          cellClass: 'extra-cell',
          keys: ['has_legal_description', 'info'],
          icons: ['ti-clip', 'paragraph', 'ti-info'],
        },
      ],
      loadingText: this.$t('app.listLoading'),
    };
  },
  created() {
    this.fetchPreviousBaseStates(this.currentPageIndex).then((response) => {
      this.baseStates = response.base_states;
      this.totalPages = response.total_pages;
    }).then((response) => {
      if (response && response.length === 0) {
        this.loadingText = this.$t('app.tasks.empty_list');
      }
    });

    if (this.$route.params.id) {
      this.fetchPreviousBaseState(this.$route.params.id).then((response) => {
      });
    }
  },
  computed: {
    ...mapGetters({
      allStatement: 'statements/allStatements',
    }),
    statementLoadingText() {
      if (this.allStatement && this.allStatement.length === 0) {
        return this.$t('app.tasks.empty_list');
      }
      return this.$t('app.listLoading');
    },
  },
  mounted() {

  },
  methods: {
    ...mapActions({
      fetchPreviousBaseStates: 'statements/fetchPreviousBaseStates',
      fetchPreviousBaseState: 'statements/fetchPreviousBaseState',
    }),
    itemSelected(index) {
      this.currentPageIndex = index;
    },
    navigateBack() {
      this.fetchPreviousBaseStates(this.currentPageIndex).then((response) => {
        this.baseStates = response.base_states;
      });
      this.$router.push({ name: 'PreviousBaseStatesScreen' });
    },
    navigateToOrigin() {
      this.$router.push({ name: 'BaseStatesScreen' });
    },
  },
  watch: {
    $route(to, from) {
      if (to.params.id) {
        this.fetchPreviousBaseState(to.params.id);
      }
    },
    currentPageIndex(newValue, oldValue) {
      this.fetchPreviousBaseStates(newValue).then((response) => {
        this.baseStates = response.base_states;
        this.totalPages = response.total_pages;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/modules/base_states/PreviousBaseStatesScreen.vue